export default __webpack_public_path__ + "fonts/Nunito-Regular.9d7a6e03.ttf";